import { defineMessages } from 'react-intl';
import { FREE_PRODUCT_KEYS } from '../model';

const ID_PREFIX = 'WacFreeBundles.';
export const messages = defineMessages({
  freeBundlesMainHeader: {
    id: `${ID_PREFIX}freeBundlesMainHeader`,
    defaultMessage: 'Our cloud products work even better together'
  },
  freeBundlesSubHeader: {
    id: `${ID_PREFIX}freeBundlesSubHeader`,
    defaultMessage: 'Get another one for free'
  },
  featureListHeader: {
    id: `${ID_PREFIX}featureListHeader`,
    defaultMessage: 'Each product on a free plan:'
  },
  primaryProductSelectedHeader: {
    id: `${ID_PREFIX}primaryProductSelectedHeader`,
    defaultMessage: 'You selected'
  },
  secondaryProductSelectionListHeader: {
    id: `${ID_PREFIX}secondaryProductSelectionListHeader`,
    defaultMessage: 'Select a second product'
  },
  jiraSoftwareProductName: {
    id: `${ID_PREFIX}jiraSoftwareProductName`,
    defaultMessage: 'Jira Software'
  },
  jiraSoftwareProductSubHeading: {
    id: `${ID_PREFIX}jiraSoftwareProductSubHeading`,
    defaultMessage: 'Project and issue tracking'
  },
  jiraSoftwareProductDescription: {
    id: `${ID_PREFIX}jiraSoftwareProductDescription`,
    defaultMessage:
      "The world's most popular project management tool and the easiest way to bring ideas in Confluence to life."
  },
  confluenceProductName: {
    id: `${ID_PREFIX}confluenceProductName`,
    defaultMessage: 'Confluence'
  },
  confluenceProductSubHeading: {
    id: `${ID_PREFIX}confluenceProductSubHeading`,
    defaultMessage: 'Document collaboration'
  },
  confluenceProductDescription: {
    id: `${ID_PREFIX}confluenceProductDescription`,
    defaultMessage:
      'Add context to your projects with a single source of truth for product requirements, release notes, and documentation.'
  },
  jiraServiceDeskProductName: {
    id: `${ID_PREFIX}jiraServiceDeskProductName`,
    defaultMessage: 'Jira Service Management'
  },
  jiraServiceDeskProductSubHeading: {
    id: `${ID_PREFIX}jiraServiceDeskProductSubHeading`,
    defaultMessage: 'High-velocity ITSM'
  },
  jiraServiceDeskProductDescription: {
    id: `${ID_PREFIX}jiraServiceDeskProductDescription`,
    defaultMessage:
      'Empower Dev and Ops teams to collaborate at high-velocity, so they can respond to business changes and deliver service experiences fast.'
  },
  jiraCoreProductName: {
    id: `${ID_PREFIX}jiraCoreProductName`,
    defaultMessage: 'Jira Work Management'
  },
  jiraCoreProductSubHeading: {
    id: `${ID_PREFIX}jiraCoreProductSubHeading`,
    defaultMessage: 'Project management for business teams'
  },
  jiraCoreProductDescription: {
    id: `${ID_PREFIX}jiraCoreProductDescription`,
    defaultMessage: 'Organize business projects and redefine teamwork.'
  },
  supportDescription: {
    id: `${ID_PREFIX}supportDescription`,
    defaultMessage: 'Supports up to 10 users or 3 agents'
  },
  storageDescription: {
    id: `${ID_PREFIX}storageDescription`,
    defaultMessage: 'Includes 2 GB of storage'
  },
  communitySupportDescription: {
    id: `${ID_PREFIX}communitySupportDescription`,
    defaultMessage: 'Offers Community support'
  },
  noCreditCardDescription: {
    id: `${ID_PREFIX}noCreditCardDescription`,
    defaultMessage: 'Is always free, no credit card needed'
  },
  largerTeamLabel: {
    id: `${ID_PREFIX}largerTeamLabel`,
    defaultMessage: 'Larger team?'
  },
  largerTeamHoverText: {
    id: `${ID_PREFIX}largerTeamHoverText`,
    defaultMessage:
      'Standard and Premium plans support up to 5,000 users or agents and include at lease 250 GB of storage'
  },
  comparePlansLabel: {
    id: `${ID_PREFIX}comparePlansLabel`,
    defaultMessage: 'Compare plans'
  },
  selectButtonLabel: {
    id: `${ID_PREFIX}selectButtonLabel`,
    defaultMessage: 'Select'
  },
  removeButtonLabel: {
    id: `${ID_PREFIX}removeButtonLabel`,
    defaultMessage: 'Remove'
  },
  nextButtonLabel: {
    id: `${ID_PREFIX}nextButtonLabel`,
    defaultMessage: 'Next'
  },
  skipButtonLabel: {
    id: `${ID_PREFIX}skipButtonLabel`,
    defaultMessage: 'Skip'
  },
  noCreditCardLabel: {
    id: `${ID_PREFIX}noCreditCardLabel`,
    defaultMessage: 'No credit card required'
  },
  termsAndConditionsLabel: {
    id: `${ID_PREFIX}termsAndConditionsLabel`,
    defaultMessage:
      "<p>By signing up, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy.</a></p>"
  },
  agreeAndContinue: {
    id: `${ID_PREFIX}agreeAndContinue`,
    defaultMessage: 'Agree and continue'
  },
  freeBundlesModalHeader: {
    id: `${ID_PREFIX}freeBundlesModalHeader`,
    defaultMessage:
      'While we wait, do you want to try a second product with {PRODUCT_NAME} for free?'
  },
  freeBundlesModalSubHeader: {
    id: `${ID_PREFIX}freeBundlesModalSubHeader`,
    defaultMessage:
      'This is <b>optional</b> and will not impact your site creation time.<br/>Select one and add to confirm.'
  },
  siteIsReadyModalHeader: {
    id: `${ID_PREFIX}siteIsReadyModalHeader`,
    defaultMessage: 'Your {PRODUCT_NAME} Cloud site is ready.'
  },
  siteIsReadyModalSubHeader: {
    id: `${ID_PREFIX}siteIsReadyModalSubHeader`,
    defaultMessage: 'Do you need more time to select another product?'
  },
  youHaveAddedSubHeader: {
    id: `${ID_PREFIX}youHaveAddedSubHeader`,
    defaultMessage: "You've added"
  },
  termsAndConditionsModalLabel: {
    id: `${ID_PREFIX}termsAndConditionsModalLabel`,
    defaultMessage:
      "<p>By clicking \"Agree\" you consent to the Atlassian <a target='_blank' href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a target='_blank' href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy.</a></p>"
  },
  agreeAndAdd: {
    id: `${ID_PREFIX}agreeAndAdd`,
    defaultMessage: 'Agree and add'
  },
  noThanks: {
    id: `${ID_PREFIX}noThanks`,
    defaultMessage: 'No thanks'
  },
  takeMeBack: {
    id: `${ID_PREFIX}takeMeBack`,
    defaultMessage: 'Yes, take me back'
  },
  goToProduct: {
    id: `${ID_PREFIX}goToProduct`,
    defaultMessage: 'Go to my {PRODUCT_NAME}'
  },
  modalJiraSoftwareProductDescription: {
    id: `${ID_PREFIX}modalJiraSoftwareProductDescription`,
    defaultMessage:
      'Pair with Confluence to organize and manage agile projects.'
  },
  modalConfluenceProductDescription: {
    id: `${ID_PREFIX}modalConfluenceProductDescription`,
    defaultMessage: 'Pair with Jira for a single source of truth.'
  },
  modalJiraCoreProductDescription: {
    id: `${ID_PREFIX}modalJiraCoreProductDescription`,
    defaultMessage:
      'Pair with Confluence to organize business projects and redefine teamwork.'
  },
  modalJiraServiceDeskProductDescription: {
    id: `${ID_PREFIX}modalJiraServiceDeskProductDescription`,
    defaultMessage: 'Pair with Confluence to streamline IT service management.'
  }
});

export const messagesByProductKey = {
  [FREE_PRODUCT_KEYS.JIRA_SOFTWARE]: {
    name: messages.jiraSoftwareProductName,
    subHeading: messages.jiraSoftwareProductSubHeading,
    description: messages.jiraSoftwareProductDescription
  },
  [FREE_PRODUCT_KEYS.CONFLUENCE]: {
    name: messages.confluenceProductName,
    subHeading: messages.confluenceProductSubHeading,
    description: messages.confluenceProductDescription
  },
  [FREE_PRODUCT_KEYS.JIRA_CORE]: {
    name: messages.jiraCoreProductName,
    subHeading: messages.jiraCoreProductSubHeading,
    description: messages.jiraCoreProductDescription
  },
  [FREE_PRODUCT_KEYS.JIRA_SERVICE_DESK]: {
    name: messages.jiraServiceDeskProductName,
    subHeading: messages.jiraServiceDeskProductSubHeading,
    description: messages.jiraServiceDeskProductDescription
  }
};

export const modalMessagesByProductKey = {
  [FREE_PRODUCT_KEYS.JIRA_SOFTWARE]: {
    name: messages.jiraSoftwareProductName,
    subHeading: messages.jiraSoftwareProductSubHeading,
    description: messages.modalJiraSoftwareProductDescription
  },
  [FREE_PRODUCT_KEYS.CONFLUENCE]: {
    name: messages.confluenceProductName,
    subHeading: messages.confluenceProductSubHeading,
    description: messages.modalConfluenceProductDescription
  },
  [FREE_PRODUCT_KEYS.JIRA_CORE]: {
    name: messages.jiraCoreProductName,
    subHeading: messages.jiraCoreProductSubHeading,
    description: messages.modalJiraCoreProductDescription
  },
  [FREE_PRODUCT_KEYS.JIRA_SERVICE_DESK]: {
    name: messages.jiraServiceDeskProductName,
    subHeading: messages.jiraServiceDeskProductSubHeading,
    description: messages.modalJiraServiceDeskProductDescription
  }
};
